import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sections: [],
};

const slice = createSlice({
  name: "classInfobyId",
  initialState,

  reducers: {
    setSections: (state, action) => {
      state.sections = action.payload;
    },

    updateSection: (state, action) => {
      const updatedSection = action.payload;
      state.sections = state.sections.map((section) =>
        section._id === updatedSection._id ? updatedSection : section
      );
    },

    removeSection: (state, action) => {
      const _id = action.payload;
      state.sections = state.sections.filter((section) => section._id !== _id);
    },
  },
});

export const { removeSection, setSections, updateSection } = slice.actions;
export default slice.reducer;
